<script setup lang="ts">
import { ref } from 'vue'

const {
  outlined = true,
  title,
  shadow,
  startOpen = false
} = defineProps<{
  startOpen?: boolean
  outlined?: boolean
  title: string
  shadow?: number
}>()

const expand = ref(startOpen)
</script>

<template>
  <div
    class="mt-2"
    :outlined="outlined"
    :shadow="shadow"
  >
    <header
      class="flex align-items-center justify-content-start cursor-pointer"
      margin-bottom="mb-0"
      @click="expand = !expand"
    >
      <p-btn
        class="p-2 mr-2"
        rounded
        outlined
      >
        <fa-icon
          class="fa-fw w-1rem h-1rem"
          :icon="`fa-solid fa-caret-${expand ? 'up' : 'down'}`"
        />
      </p-btn>
      <h2 class="text-xl text-primary uppercase m-0">
        {{ title }}
      </h2>
    </header>
    <transition name="p-toggleable-content">
      <section
        v-if="expand"
        role="region"
      >
        <div class="mt-4">
          <slot />
        </div>
      </section>
    </transition>
  </div>
</template>
